var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_responsive)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:_vm._class},[_vm._t("default")],2)]):_c('table',{staticClass:"table",class:_vm._class},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }